"use client";

import * as React from "react";

import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

import { cn } from "utils/cn";

type RadioOptionProps = {
  value: string;
  label: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
};

function RadioGroup({ className, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return <RadioGroupPrimitive.Root data-slot="radio-group" className={cn("grid gap-3", className)} {...props} />;
}

/**
 * RadioGroupItem now acts as the full "pill" (container).
 */
function RadioGroupItem({ className, children, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        "group w-full data-[state=checked]:border-general-green-700 data-[state=checked]:bg-general-mint-600",
        "border-general-gray-300 border rounded-lg p-3 flex items-center gap-3 h-12 transition-colors duration-150 cursor-pointer",
        className,
      )}
      {...props}
    >
      <div
        className={cn(
          "flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center",
          // koristimo group-data-[state=checked] da promijenimo stil djeteta kad parent ima data-state=checked
          "border border-general-gray-300 group-data-[state=checked]:border-general-green-700 group-data-[state=checked]:bg-general-green-50 transition-colors duration-150",
        )}
      >
        <RadioGroupPrimitive.Indicator
          data-slot="radio-group-indicator"
          className="w-2.5 h-2.5 rounded-full bg-general-green-700 opacity-0 group-data-[state=checked]:opacity-100 transition-opacity duration-150"
        />
      </div>
      <div className="flex-1 text-left">{children}</div>
    </RadioGroupPrimitive.Item>
  );
}

function RadioOption({ value, label, description, className = "" }: RadioOptionProps) {
  return (
    <label className={`block ${className}`}>
      <RadioGroupItem value={value}>
        <div>
          <div className="text-sm font-medium text-foreground">{label}</div>
          {description && <div className="text-xs text-muted-foreground mt-0.5">{description}</div>}
        </div>
      </RadioGroupItem>
    </label>
  );
}

export { RadioGroup, RadioGroupItem, RadioOption };
